/**
 * AUTO-GENERATED by scripts/build-icon-map.js — do not edit by hand.
 *
 * CORE icon map: the icons needed before first paint (public/SEO routes, the marketing
 * components, app chrome, and the lookup's own fallbacks). 268 names,
 * 457 variant entries, 457 imports.
 *
 * The remaining 227 names (350 entries) live in
 * ./iconMap.deferred.generated.js and are fetched on demand — see constants/iconRegistry.js.
 * Splitting them out took 171 KB gzip off the entry bundle.
 *
 * Regenerate: npm run build:icons
 */

import { faAlignLeft as faAlignLeft__far } from '@fortawesome/pro-regular-svg-icons/faAlignLeft';
import { faAngleLeft as faAngleLeft__far } from '@fortawesome/pro-regular-svg-icons/faAngleLeft';
import { faAngleRight as faAngleRight__far } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faAngleRight as faAngleRight__fas } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faArchive as faArchive__far } from '@fortawesome/pro-regular-svg-icons/faArchive';
import { faArrowDown as faArrowDown__far } from '@fortawesome/pro-regular-svg-icons/faArrowDown';
import { faArrowDown as faArrowDown__fas } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import { faArrowDownAZ as faArrowDownAZ__far } from '@fortawesome/pro-regular-svg-icons/faArrowDownAZ';
import { faArrowDownToLine as faArrowDownToLine__far } from '@fortawesome/pro-regular-svg-icons/faArrowDownToLine';
import { faArrowDownToLine as faArrowDownToLine__fas } from '@fortawesome/pro-solid-svg-icons/faArrowDownToLine';
import { faArrowLeft as faArrowLeft__far } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { faArrowRight as faArrowRight__far } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { faArrowRight as faArrowRight__fas } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowRightFromBracket as faArrowRightFromBracket__far } from '@fortawesome/pro-regular-svg-icons/faArrowRightFromBracket';
import { faArrowRightFromBracket as faArrowRightFromBracket__fas } from '@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket';
import { faArrowRightToBracket as faArrowRightToBracket__far } from '@fortawesome/pro-regular-svg-icons/faArrowRightToBracket';
import { faArrowRightToBracket as faArrowRightToBracket__fas } from '@fortawesome/pro-solid-svg-icons/faArrowRightToBracket';
import { faArrowRotateRight as faArrowRotateRight__far } from '@fortawesome/pro-regular-svg-icons/faArrowRotateRight';
import { faArrowRotateRight as faArrowRotateRight__fas } from '@fortawesome/pro-solid-svg-icons/faArrowRotateRight';
import { faArrowTrendUp as faArrowTrendUp__far } from '@fortawesome/pro-regular-svg-icons/faArrowTrendUp';
import { faArrowUp as faArrowUp__far } from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import { faArrowUp as faArrowUp__fas } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faArrowUpRight as faArrowUpRight__far } from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import { faArrowUpRight as faArrowUpRight__fas } from '@fortawesome/pro-solid-svg-icons/faArrowUpRight';
import { faArrowUpRightFromSquare as faArrowUpRightFromSquare__far } from '@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare';
import { faArrowUpRightFromSquare as faArrowUpRightFromSquare__fas } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { faArrowUpWideShort as faArrowUpWideShort__far } from '@fortawesome/pro-regular-svg-icons/faArrowUpWideShort';
import { faArrowsRotate as faArrowsRotate__far } from '@fortawesome/pro-regular-svg-icons/faArrowsRotate';
import { faArrowsRotate as faArrowsRotate__fas } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faArrowsToDottedLine as faArrowsToDottedLine__far } from '@fortawesome/pro-regular-svg-icons/faArrowsToDottedLine';
import { faBagShopping as faBagShopping__far } from '@fortawesome/pro-regular-svg-icons/faBagShopping';
import { faBagShopping as faBagShopping__fas } from '@fortawesome/pro-solid-svg-icons/faBagShopping';
import { faBan as faBan__far } from '@fortawesome/pro-regular-svg-icons/faBan';
import { faBan as faBan__fas } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBars as faBars__far } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faBars as faBars__fas } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBatteryEmpty as faBatteryEmpty__far } from '@fortawesome/pro-regular-svg-icons/faBatteryEmpty';
import { faBolt as faBolt__far } from '@fortawesome/pro-regular-svg-icons/faBolt';
import { faBolt as faBolt__fas } from '@fortawesome/pro-solid-svg-icons/faBolt';
import { faBook as faBook__far } from '@fortawesome/pro-regular-svg-icons/faBook';
import { faBook as faBook__fas } from '@fortawesome/pro-solid-svg-icons/faBook';
import { faBookBlank as faBookBlank__far } from '@fortawesome/pro-regular-svg-icons/faBookBlank';
import { faBookOpen as faBookOpen__far } from '@fortawesome/pro-regular-svg-icons/faBookOpen';
import { faBookOpen as faBookOpen__fas } from '@fortawesome/pro-solid-svg-icons/faBookOpen';
import { faBookmark as faBookmark__far } from '@fortawesome/pro-regular-svg-icons/faBookmark';
import { faBookmark as faBookmark__fas } from '@fortawesome/pro-solid-svg-icons/faBookmark';
import { faBox as faBox__far } from '@fortawesome/pro-regular-svg-icons/faBox';
import { faBoxArchive as faBoxArchive__far } from '@fortawesome/pro-regular-svg-icons/faBoxArchive';
import { faBoxArchive as faBoxArchive__fas } from '@fortawesome/pro-solid-svg-icons/faBoxArchive';
import { faBoxOpen as faBoxOpen__far } from '@fortawesome/pro-regular-svg-icons/faBoxOpen';
import { faBoxOpen as faBoxOpen__fas } from '@fortawesome/pro-solid-svg-icons/faBoxOpen';
import { faBrain as faBrain__far } from '@fortawesome/pro-regular-svg-icons/faBrain';
import { faBrain as faBrain__fas } from '@fortawesome/pro-solid-svg-icons/faBrain';
import { faBriefcase as faBriefcase__far } from '@fortawesome/pro-regular-svg-icons/faBriefcase';
import { faBriefcase as faBriefcase__fas } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faBrightness as faBrightness__far } from '@fortawesome/pro-regular-svg-icons/faBrightness';
import { faBuilding as faBuilding__far } from '@fortawesome/pro-regular-svg-icons/faBuilding';
import { faBuilding as faBuilding__fas } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBullhorn as faBullhorn__far } from '@fortawesome/pro-regular-svg-icons/faBullhorn';
import { faBullhorn as faBullhorn__fas } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faBullseye as faBullseye__far } from '@fortawesome/pro-regular-svg-icons/faBullseye';
import { faBullseye as faBullseye__fas } from '@fortawesome/pro-solid-svg-icons/faBullseye';
import { faCalculator as faCalculator__far } from '@fortawesome/pro-regular-svg-icons/faCalculator';
import { faCalendar as faCalendar__far } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCalendarCheck as faCalendarCheck__far } from '@fortawesome/pro-regular-svg-icons/faCalendarCheck';
import { faCalendarCheck as faCalendarCheck__fas } from '@fortawesome/pro-solid-svg-icons/faCalendarCheck';
import { faCalendarClock as faCalendarClock__far } from '@fortawesome/pro-regular-svg-icons/faCalendarClock';
import { faCalendarClock as faCalendarClock__fas } from '@fortawesome/pro-solid-svg-icons/faCalendarClock';
import { faCalendarDays as faCalendarDays__far } from '@fortawesome/pro-regular-svg-icons/faCalendarDays';
import { faCalendarDays as faCalendarDays__fas } from '@fortawesome/pro-solid-svg-icons/faCalendarDays';
import { faCalendarPlus as faCalendarPlus__far } from '@fortawesome/pro-regular-svg-icons/faCalendarPlus';
import { faCartPlus as faCartPlus__far } from '@fortawesome/pro-regular-svg-icons/faCartPlus';
import { faCartShopping as faCartShopping__far } from '@fortawesome/pro-regular-svg-icons/faCartShopping';
import { faCartShopping as faCartShopping__fas } from '@fortawesome/pro-solid-svg-icons/faCartShopping';
import { faChalkboard as faChalkboard__far } from '@fortawesome/pro-regular-svg-icons/faChalkboard';
import { faChalkboard as faChalkboard__fas } from '@fortawesome/pro-solid-svg-icons/faChalkboard';
import { faChalkboardUser as faChalkboardUser__far } from '@fortawesome/pro-regular-svg-icons/faChalkboardUser';
import { faChalkboardUser as faChalkboardUser__fas } from '@fortawesome/pro-solid-svg-icons/faChalkboardUser';
import { faChartColumn as faChartColumn__far } from '@fortawesome/pro-regular-svg-icons/faChartColumn';
import { faChartColumn as faChartColumn__fas } from '@fortawesome/pro-solid-svg-icons/faChartColumn';
import { faChartLine as faChartLine__far } from '@fortawesome/pro-regular-svg-icons/faChartLine';
import { faChartLine as faChartLine__fas } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faChartPie as faChartPie__far } from '@fortawesome/pro-regular-svg-icons/faChartPie';
import { faChartPie as faChartPie__fas } from '@fortawesome/pro-solid-svg-icons/faChartPie';
import { faChartSimple as faChartSimple__far } from '@fortawesome/pro-regular-svg-icons/faChartSimple';
import { faChartSimple as faChartSimple__fas } from '@fortawesome/pro-solid-svg-icons/faChartSimple';
import { faCheck as faCheck__far } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faCheck as faCheck__fas } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronDown as faChevronDown__far } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronDown as faChevronDown__fas } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft as faChevronLeft__far } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronLeft as faChevronLeft__fas } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as faChevronRight__far } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronRight as faChevronRight__fas } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp as faChevronUp__far } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronUp as faChevronUp__fas } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChurch as faChurch__far } from '@fortawesome/pro-regular-svg-icons/faChurch';
import { faChurch as faChurch__fas } from '@fortawesome/pro-solid-svg-icons/faChurch';
import { faCircle as faCircle__fal } from '@fortawesome/pro-light-svg-icons/faCircle';
import { faCircle as faCircle__far } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircle as faCircle__fas } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleArrowDown as faCircleArrowDown__far } from '@fortawesome/pro-regular-svg-icons/faCircleArrowDown';
import { faCircleCheck as faCircleCheck__fal } from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import { faCircleCheck as faCircleCheck__far } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { faCircleCheck as faCircleCheck__fas } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleExclamation as faCircleExclamation__far } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation';
import { faCircleExclamation as faCircleExclamation__fas } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faCircleInfo as faCircleInfo__far } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { faCircleInfo as faCircleInfo__fas } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleNotch as faCircleNotch__far } from '@fortawesome/pro-regular-svg-icons/faCircleNotch';
import { faCircleNotch as faCircleNotch__fas } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCirclePlus as faCirclePlus__far } from '@fortawesome/pro-regular-svg-icons/faCirclePlus';
import { faCircleQuestion as faCircleQuestion__far } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';
import { faCircleQuestion as faCircleQuestion__fas } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faCircleStop as faCircleStop__far } from '@fortawesome/pro-regular-svg-icons/faCircleStop';
import { faCircleUser as faCircleUser__far } from '@fortawesome/pro-regular-svg-icons/faCircleUser';
import { faCircleXmark as faCircleXmark__far } from '@fortawesome/pro-regular-svg-icons/faCircleXmark';
import { faCircleXmark as faCircleXmark__fas } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faClapperboard as faClapperboard__far } from '@fortawesome/pro-regular-svg-icons/faClapperboard';
import { faClapperboard as faClapperboard__fas } from '@fortawesome/pro-solid-svg-icons/faClapperboard';
import { faClipboard as faClipboard__far } from '@fortawesome/pro-regular-svg-icons/faClipboard';
import { faClipboardCheck as faClipboardCheck__far } from '@fortawesome/pro-regular-svg-icons/faClipboardCheck';
import { faClipboardCheck as faClipboardCheck__fas } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faClipboardList as faClipboardList__far } from '@fortawesome/pro-regular-svg-icons/faClipboardList';
import { faClipboardList as faClipboardList__fas } from '@fortawesome/pro-solid-svg-icons/faClipboardList';
import { faClock as faClock__far } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faClock as faClock__fas } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faClockRotateLeft as faClockRotateLeft__fal } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { faClockRotateLeft as faClockRotateLeft__far } from '@fortawesome/pro-regular-svg-icons/faClockRotateLeft';
import { faClockRotateLeft as faClockRotateLeft__fas } from '@fortawesome/pro-solid-svg-icons/faClockRotateLeft';
import { faClone as faClone__far } from '@fortawesome/pro-regular-svg-icons/faClone';
import { faClone as faClone__fas } from '@fortawesome/pro-solid-svg-icons/faClone';
import { faCloudArrowUp as faCloudArrowUp__far } from '@fortawesome/pro-regular-svg-icons/faCloudArrowUp';
import { faCode as faCode__far } from '@fortawesome/pro-regular-svg-icons/faCode';
import { faCode as faCode__fas } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faCodeBranch as faCodeBranch__far } from '@fortawesome/pro-regular-svg-icons/faCodeBranch';
import { faCodeBranch as faCodeBranch__fas } from '@fortawesome/pro-solid-svg-icons/faCodeBranch';
import { faCodeCompare as faCodeCompare__far } from '@fortawesome/pro-regular-svg-icons/faCodeCompare';
import { faCoffee as faCoffee__far } from '@fortawesome/pro-regular-svg-icons/faCoffee';
import { faCoins as faCoins__far } from '@fortawesome/pro-regular-svg-icons/faCoins';
import { faCoins as faCoins__fas } from '@fortawesome/pro-solid-svg-icons/faCoins';
import { faComment as faComment__far } from '@fortawesome/pro-regular-svg-icons/faComment';
import { faComment as faComment__fas } from '@fortawesome/pro-solid-svg-icons/faComment';
import { faCommentDots as faCommentDots__far } from '@fortawesome/pro-regular-svg-icons/faCommentDots';
import { faComments as faComments__far } from '@fortawesome/pro-regular-svg-icons/faComments';
import { faComments as faComments__fas } from '@fortawesome/pro-solid-svg-icons/faComments';
import { faCompass as faCompass__far } from '@fortawesome/pro-regular-svg-icons/faCompass';
import { faCompass as faCompass__fas } from '@fortawesome/pro-solid-svg-icons/faCompass';
import { faCompress as faCompress__far } from '@fortawesome/pro-regular-svg-icons/faCompress';
import { faCopy as faCopy__far } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { faCopy as faCopy__fas } from '@fortawesome/pro-solid-svg-icons/faCopy';
import { faCreditCard as faCreditCard__far } from '@fortawesome/pro-regular-svg-icons/faCreditCard';
import { faCreditCard as faCreditCard__fas } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faCross as faCross__far } from '@fortawesome/pro-regular-svg-icons/faCross';
import { faCross as faCross__fas } from '@fortawesome/pro-solid-svg-icons/faCross';
import { faCrown as faCrown__far } from '@fortawesome/pro-regular-svg-icons/faCrown';
import { faCrown as faCrown__fas } from '@fortawesome/pro-solid-svg-icons/faCrown';
import { faCube as faCube__far } from '@fortawesome/pro-regular-svg-icons/faCube';
import { faCube as faCube__fas } from '@fortawesome/pro-solid-svg-icons/faCube';
import { faCubes as faCubes__far } from '@fortawesome/pro-regular-svg-icons/faCubes';
import { faCubes as faCubes__fas } from '@fortawesome/pro-solid-svg-icons/faCubes';
import { faDesktop as faDesktop__far } from '@fortawesome/pro-regular-svg-icons/faDesktop';
import { faDesktop as faDesktop__fas } from '@fortawesome/pro-solid-svg-icons/faDesktop';
import { faDiagramProject as faDiagramProject__far } from '@fortawesome/pro-regular-svg-icons/faDiagramProject';
import { faDiagramProject as faDiagramProject__fas } from '@fortawesome/pro-solid-svg-icons/faDiagramProject';
import { faDownload as faDownload__far } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faDumbbell as faDumbbell__far } from '@fortawesome/pro-regular-svg-icons/faDumbbell';
import { faDumbbell as faDumbbell__fas } from '@fortawesome/pro-solid-svg-icons/faDumbbell';
import { faEllipsis as faEllipsis__far } from '@fortawesome/pro-regular-svg-icons/faEllipsis';
import { faEnvelope as faEnvelope__far } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faEnvelope as faEnvelope__fas } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEnvelopeCircleCheck as faEnvelopeCircleCheck__far } from '@fortawesome/pro-regular-svg-icons/faEnvelopeCircleCheck';
import { faEraser as faEraser__far } from '@fortawesome/pro-regular-svg-icons/faEraser';
import { faEraser as faEraser__fas } from '@fortawesome/pro-solid-svg-icons/faEraser';
import { faEye as faEye__far } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faEye as faEye__fas } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faEyeSlash as faEyeSlash__far } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';
import { faFile as faFile__far } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faFile as faFile__fas } from '@fortawesome/pro-solid-svg-icons/faFile';
import { faFileArrowUp as faFileArrowUp__far } from '@fortawesome/pro-regular-svg-icons/faFileArrowUp';
import { faFileAudio as faFileAudio__far } from '@fortawesome/pro-regular-svg-icons/faFileAudio';
import { faFileCad as faFileCad__far } from '@fortawesome/pro-regular-svg-icons/faFileCad';
import { faFileCode as faFileCode__far } from '@fortawesome/pro-regular-svg-icons/faFileCode';
import { faFileCode as faFileCode__fas } from '@fortawesome/pro-solid-svg-icons/faFileCode';
import { faFileCsv as faFileCsv__far } from '@fortawesome/pro-regular-svg-icons/faFileCsv';
import { faFileDoc as faFileDoc__far } from '@fortawesome/pro-regular-svg-icons/faFileDoc';
import { faFileEps as faFileEps__far } from '@fortawesome/pro-regular-svg-icons/faFileEps';
import { faFileExcel as faFileExcel__far } from '@fortawesome/pro-regular-svg-icons/faFileExcel';
import { faFileExport as faFileExport__far } from '@fortawesome/pro-regular-svg-icons/faFileExport';
import { faFileExport as faFileExport__fas } from '@fortawesome/pro-solid-svg-icons/faFileExport';
import { faFileGif as faFileGif__far } from '@fortawesome/pro-regular-svg-icons/faFileGif';
import { faFileImage as faFileImage__far } from '@fortawesome/pro-regular-svg-icons/faFileImage';
import { faFileImport as faFileImport__far } from '@fortawesome/pro-regular-svg-icons/faFileImport';
import { faFileImport as faFileImport__fas } from '@fortawesome/pro-solid-svg-icons/faFileImport';
import { faFileJpg as faFileJpg__far } from '@fortawesome/pro-regular-svg-icons/faFileJpg';
import { faFileLines as faFileLines__far } from '@fortawesome/pro-regular-svg-icons/faFileLines';
import { faFileLines as faFileLines__fas } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { faFileMov as faFileMov__far } from '@fortawesome/pro-regular-svg-icons/faFileMov';
import { faFileMp3 as faFileMp3__far } from '@fortawesome/pro-regular-svg-icons/faFileMp3';
import { faFileMp4 as faFileMp4__far } from '@fortawesome/pro-regular-svg-icons/faFileMp4';
import { faFilePdf as faFilePdf__far } from '@fortawesome/pro-regular-svg-icons/faFilePdf';
import { faFilePdf as faFilePdf__fas } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFilePlus as faFilePlus__far } from '@fortawesome/pro-regular-svg-icons/faFilePlus';
import { faFilePng as faFilePng__far } from '@fortawesome/pro-regular-svg-icons/faFilePng';
import { faFilePowerpoint as faFilePowerpoint__far } from '@fortawesome/pro-regular-svg-icons/faFilePowerpoint';
import { faFilePowerpoint as faFilePowerpoint__fas } from '@fortawesome/pro-solid-svg-icons/faFilePowerpoint';
import { faFileSpreadsheet as faFileSpreadsheet__far } from '@fortawesome/pro-regular-svg-icons/faFileSpreadsheet';
import { faFileSpreadsheet as faFileSpreadsheet__fas } from '@fortawesome/pro-solid-svg-icons/faFileSpreadsheet';
import { faFileSvg as faFileSvg__far } from '@fortawesome/pro-regular-svg-icons/faFileSvg';
import { faFileText as faFileText__far } from '@fortawesome/pro-regular-svg-icons/faFileText';
import { faFileVideo as faFileVideo__far } from '@fortawesome/pro-regular-svg-icons/faFileVideo';
import { faFileWord as faFileWord__far } from '@fortawesome/pro-regular-svg-icons/faFileWord';
import { faFileXml as faFileXml__far } from '@fortawesome/pro-regular-svg-icons/faFileXml';
import { faFileZipper as faFileZipper__far } from '@fortawesome/pro-regular-svg-icons/faFileZipper';
import { faFiles as faFiles__far } from '@fortawesome/pro-regular-svg-icons/faFiles';
import { faFilm as faFilm__far } from '@fortawesome/pro-regular-svg-icons/faFilm';
import { faFilm as faFilm__fas } from '@fortawesome/pro-solid-svg-icons/faFilm';
import { faFilter as faFilter__far } from '@fortawesome/pro-regular-svg-icons/faFilter';
import { faFilterList as faFilterList__far } from '@fortawesome/pro-regular-svg-icons/faFilterList';
import { faFire as faFire__far } from '@fortawesome/pro-regular-svg-icons/faFire';
import { faFire as faFire__fas } from '@fortawesome/pro-solid-svg-icons/faFire';
import { faFlag as faFlag__far } from '@fortawesome/pro-regular-svg-icons/faFlag';
import { faFlagUsa as faFlagUsa__far } from '@fortawesome/pro-regular-svg-icons/faFlagUsa';
import { faFlask as faFlask__far } from '@fortawesome/pro-regular-svg-icons/faFlask';
import { faFlask as faFlask__fas } from '@fortawesome/pro-solid-svg-icons/faFlask';
import { faFolder as faFolder__far } from '@fortawesome/pro-regular-svg-icons/faFolder';
import { faFolder as faFolder__fas } from '@fortawesome/pro-solid-svg-icons/faFolder';
import { faFolderMagnifyingGlass as faFolderMagnifyingGlass__far } from '@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass';
import { faFolderMinus as faFolderMinus__far } from '@fortawesome/pro-regular-svg-icons/faFolderMinus';
import { faFolderOpen as faFolderOpen__far } from '@fortawesome/pro-regular-svg-icons/faFolderOpen';
import { faFolderOpen as faFolderOpen__fas } from '@fortawesome/pro-solid-svg-icons/faFolderOpen';
import { faFolderPlus as faFolderPlus__far } from '@fortawesome/pro-regular-svg-icons/faFolderPlus';
import { faFolderTree as faFolderTree__far } from '@fortawesome/pro-regular-svg-icons/faFolderTree';
import { faFolderTree as faFolderTree__fas } from '@fortawesome/pro-solid-svg-icons/faFolderTree';
import { faFrog as faFrog__far } from '@fortawesome/pro-regular-svg-icons/faFrog';
import { faGamepad as faGamepad__far } from '@fortawesome/pro-regular-svg-icons/faGamepad';
import { faGamepad as faGamepad__fas } from '@fortawesome/pro-solid-svg-icons/faGamepad';
import { faGaugeHigh as faGaugeHigh__far } from '@fortawesome/pro-regular-svg-icons/faGaugeHigh';
import { faGaugeHigh as faGaugeHigh__fas } from '@fortawesome/pro-solid-svg-icons/faGaugeHigh';
import { faGear as faGear__far } from '@fortawesome/pro-regular-svg-icons/faGear';
import { faGears as faGears__far } from '@fortawesome/pro-regular-svg-icons/faGears';
import { faGears as faGears__fas } from '@fortawesome/pro-solid-svg-icons/faGears';
import { faGem as faGem__far } from '@fortawesome/pro-regular-svg-icons/faGem';
import { faGem as faGem__fas } from '@fortawesome/pro-solid-svg-icons/faGem';
import { faGhost as faGhost__far } from '@fortawesome/pro-regular-svg-icons/faGhost';
import { faGhost as faGhost__fas } from '@fortawesome/pro-solid-svg-icons/faGhost';
import { faGlobe as faGlobe__far } from '@fortawesome/pro-regular-svg-icons/faGlobe';
import { faGlobe as faGlobe__fas } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGraduationCap as faGraduationCap__far } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faGraduationCap as faGraduationCap__fas } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faGrid2 as faGrid2__far } from '@fortawesome/pro-regular-svg-icons/faGrid2';
import { faGrid2 as faGrid2__fas } from '@fortawesome/pro-solid-svg-icons/faGrid2';
import { faHammer as faHammer__far } from '@fortawesome/pro-regular-svg-icons/faHammer';
import { faHammer as faHammer__fas } from '@fortawesome/pro-solid-svg-icons/faHammer';
import { faHand as faHand__far } from '@fortawesome/pro-regular-svg-icons/faHand';
import { faHand as faHand__fas } from '@fortawesome/pro-solid-svg-icons/faHand';
import { faHandHoldingDollar as faHandHoldingDollar__far } from '@fortawesome/pro-regular-svg-icons/faHandHoldingDollar';
import { faHandHoldingDollar as faHandHoldingDollar__fas } from '@fortawesome/pro-solid-svg-icons/faHandHoldingDollar';
import { faHandshake as faHandshake__far } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faHandshake as faHandshake__fas } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHeart as faHeart__far } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faHeart as faHeart__fas } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHeartPulse as faHeartPulse__far } from '@fortawesome/pro-regular-svg-icons/faHeartPulse';
import { faHeartPulse as faHeartPulse__fas } from '@fortawesome/pro-solid-svg-icons/faHeartPulse';
import { faHome as faHome__far } from '@fortawesome/pro-regular-svg-icons/faHome';
import { faHome as faHome__fas } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faHouse as faHouse__far } from '@fortawesome/pro-regular-svg-icons/faHouse';
import { faHouse as faHouse__fas } from '@fortawesome/pro-solid-svg-icons/faHouse';
import { faImage as faImage__far } from '@fortawesome/pro-regular-svg-icons/faImage';
import { faImage as faImage__fas } from '@fortawesome/pro-solid-svg-icons/faImage';
import { faIndustry as faIndustry__far } from '@fortawesome/pro-regular-svg-icons/faIndustry';
import { faInfinity as faInfinity__far } from '@fortawesome/pro-regular-svg-icons/faInfinity';
import { faKey as faKey__far } from '@fortawesome/pro-regular-svg-icons/faKey';
import { faKey as faKey__fas } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLandmark as faLandmark__far } from '@fortawesome/pro-regular-svg-icons/faLandmark';
import { faLandmark as faLandmark__fas } from '@fortawesome/pro-solid-svg-icons/faLandmark';
import { faLaptop as faLaptop__far } from '@fortawesome/pro-regular-svg-icons/faLaptop';
import { faLaptop as faLaptop__fas } from '@fortawesome/pro-solid-svg-icons/faLaptop';
import { faLayerGroup as faLayerGroup__far } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import { faLayerGroup as faLayerGroup__fas } from '@fortawesome/pro-solid-svg-icons/faLayerGroup';
import { faLightbulb as faLightbulb__far } from '@fortawesome/pro-regular-svg-icons/faLightbulb';
import { faLightbulb as faLightbulb__fas } from '@fortawesome/pro-solid-svg-icons/faLightbulb';
import { faLink as faLink__far } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faLink as faLink__fas } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faList as faList__far } from '@fortawesome/pro-regular-svg-icons/faList';
import { faList as faList__fas } from '@fortawesome/pro-solid-svg-icons/faList';
import { faListCheck as faListCheck__far } from '@fortawesome/pro-regular-svg-icons/faListCheck';
import { faListCheck as faListCheck__fas } from '@fortawesome/pro-solid-svg-icons/faListCheck';
import { faListOl as faListOl__far } from '@fortawesome/pro-regular-svg-icons/faListOl';
import { faListOl as faListOl__fas } from '@fortawesome/pro-solid-svg-icons/faListOl';
import { faLocationDot as faLocationDot__far } from '@fortawesome/pro-regular-svg-icons/faLocationDot';
import { faLocationDot as faLocationDot__fas } from '@fortawesome/pro-solid-svg-icons/faLocationDot';
import { faLock as faLock__far } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faLock as faLock__fas } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faMagnifyingGlass as faMagnifyingGlass__far } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlass as faMagnifyingGlass__fas } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlassChart as faMagnifyingGlassChart__far } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassChart';
import { faMagnifyingGlassChart as faMagnifyingGlassChart__fas } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassChart';
import { faMessage as faMessage__far } from '@fortawesome/pro-regular-svg-icons/faMessage';
import { faMessage as faMessage__fas } from '@fortawesome/pro-solid-svg-icons/faMessage';
import { faMessageDots as faMessageDots__far } from '@fortawesome/pro-regular-svg-icons/faMessageDots';
import { faMessages as faMessages__far } from '@fortawesome/pro-regular-svg-icons/faMessages';
import { faMicrochip as faMicrochip__far } from '@fortawesome/pro-regular-svg-icons/faMicrochip';
import { faMicrochip as faMicrochip__fas } from '@fortawesome/pro-solid-svg-icons/faMicrochip';
import { faMicrophone as faMicrophone__far } from '@fortawesome/pro-regular-svg-icons/faMicrophone';
import { faMicrophone as faMicrophone__fas } from '@fortawesome/pro-solid-svg-icons/faMicrophone';
import { faMicrophoneLines as faMicrophoneLines__far } from '@fortawesome/pro-regular-svg-icons/faMicrophoneLines';
import { faMicrophoneLines as faMicrophoneLines__fas } from '@fortawesome/pro-solid-svg-icons/faMicrophoneLines';
import { faMinus as faMinus__far } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { faMinus as faMinus__fas } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faMobile as faMobile__far } from '@fortawesome/pro-regular-svg-icons/faMobile';
import { faMobileScreen as faMobileScreen__fal } from '@fortawesome/pro-light-svg-icons/faMobileScreen';
import { faMobileScreen as faMobileScreen__far } from '@fortawesome/pro-regular-svg-icons/faMobileScreen';
import { faMobileScreen as faMobileScreen__fas } from '@fortawesome/pro-solid-svg-icons/faMobileScreen';
import { faMobileScreenButton as faMobileScreenButton__far } from '@fortawesome/pro-regular-svg-icons/faMobileScreenButton';
import { faMobileScreenButton as faMobileScreenButton__fas } from '@fortawesome/pro-solid-svg-icons/faMobileScreenButton';
import { faMoon as faMoon__far } from '@fortawesome/pro-regular-svg-icons/faMoon';
import { faMoon as faMoon__fas } from '@fortawesome/pro-solid-svg-icons/faMoon';
import { faMountainSun as faMountainSun__far } from '@fortawesome/pro-regular-svg-icons/faMountainSun';
import { faMountainSun as faMountainSun__fas } from '@fortawesome/pro-solid-svg-icons/faMountainSun';
import { faMugHot as faMugHot__far } from '@fortawesome/pro-regular-svg-icons/faMugHot';
import { faMugHot as faMugHot__fas } from '@fortawesome/pro-solid-svg-icons/faMugHot';
import { faMusic as faMusic__far } from '@fortawesome/pro-regular-svg-icons/faMusic';
import { faMusic as faMusic__fas } from '@fortawesome/pro-solid-svg-icons/faMusic';
import { faNewspaper as faNewspaper__far } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
import { faNewspaper as faNewspaper__fas } from '@fortawesome/pro-solid-svg-icons/faNewspaper';
import { faObjectGroup as faObjectGroup__far } from '@fortawesome/pro-regular-svg-icons/faObjectGroup';
import { faObjectGroup as faObjectGroup__fas } from '@fortawesome/pro-solid-svg-icons/faObjectGroup';
import { faPaintbrush as faPaintbrush__far } from '@fortawesome/pro-regular-svg-icons/faPaintbrush';
import { faPaintbrush as faPaintbrush__fas } from '@fortawesome/pro-solid-svg-icons/faPaintbrush';
import { faPalette as faPalette__far } from '@fortawesome/pro-regular-svg-icons/faPalette';
import { faPalette as faPalette__fas } from '@fortawesome/pro-solid-svg-icons/faPalette';
import { faPaperPlane as faPaperPlane__far } from '@fortawesome/pro-regular-svg-icons/faPaperPlane';
import { faPaperPlane as faPaperPlane__fas } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faPaperclip as faPaperclip__far } from '@fortawesome/pro-regular-svg-icons/faPaperclip';
import { faPause as faPause__far } from '@fortawesome/pro-regular-svg-icons/faPause';
import { faPause as faPause__fas } from '@fortawesome/pro-solid-svg-icons/faPause';
import { faPen as faPen__far } from '@fortawesome/pro-regular-svg-icons/faPen';
import { faPen as faPen__fas } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faPenFancy as faPenFancy__far } from '@fortawesome/pro-regular-svg-icons/faPenFancy';
import { faPenFancy as faPenFancy__fas } from '@fortawesome/pro-solid-svg-icons/faPenFancy';
import { faPenNib as faPenNib__far } from '@fortawesome/pro-regular-svg-icons/faPenNib';
import { faPenNib as faPenNib__fas } from '@fortawesome/pro-solid-svg-icons/faPenNib';
import { faPenToSquare as faPenToSquare__far } from '@fortawesome/pro-regular-svg-icons/faPenToSquare';
import { faPenToSquare as faPenToSquare__fas } from '@fortawesome/pro-solid-svg-icons/faPenToSquare';
import { faPencil as faPencil__far } from '@fortawesome/pro-regular-svg-icons/faPencil';
import { faPencil as faPencil__fas } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faPeopleRoof as faPeopleRoof__far } from '@fortawesome/pro-regular-svg-icons/faPeopleRoof';
import { faPeopleRoof as faPeopleRoof__fas } from '@fortawesome/pro-solid-svg-icons/faPeopleRoof';
import { faPhone as faPhone__far } from '@fortawesome/pro-regular-svg-icons/faPhone';
import { faPhone as faPhone__fas } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPlay as faPlay__far } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { faPlay as faPlay__fas } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faPlug as faPlug__far } from '@fortawesome/pro-regular-svg-icons/faPlug';
import { faPlug as faPlug__fas } from '@fortawesome/pro-solid-svg-icons/faPlug';
import { faPlus as faPlus__far } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faPlus as faPlus__fas } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faPuzzlePiece as faPuzzlePiece__far } from '@fortawesome/pro-regular-svg-icons/faPuzzlePiece';
import { faQuestion as faQuestion__far } from '@fortawesome/pro-regular-svg-icons/faQuestion';
import { faQuotes as faQuotes__far } from '@fortawesome/pro-regular-svg-icons/faQuotes';
import { faQuotes as faQuotes__fas } from '@fortawesome/pro-solid-svg-icons/faQuotes';
import { faRightLeft as faRightLeft__far } from '@fortawesome/pro-regular-svg-icons/faRightLeft';
import { faRightLeft as faRightLeft__fas } from '@fortawesome/pro-solid-svg-icons/faRightLeft';
import { faRobot as faRobot__far } from '@fortawesome/pro-regular-svg-icons/faRobot';
import { faRobot as faRobot__fas } from '@fortawesome/pro-solid-svg-icons/faRobot';
import { faRocket as faRocket__far } from '@fortawesome/pro-regular-svg-icons/faRocket';
import { faRocket as faRocket__fas } from '@fortawesome/pro-solid-svg-icons/faRocket';
import { faRoute as faRoute__far } from '@fortawesome/pro-regular-svg-icons/faRoute';
import { faScaleBalanced as faScaleBalanced__far } from '@fortawesome/pro-regular-svg-icons/faScaleBalanced';
import { faScaleBalanced as faScaleBalanced__fas } from '@fortawesome/pro-solid-svg-icons/faScaleBalanced';
import { faScrewdriverWrench as faScrewdriverWrench__far } from '@fortawesome/pro-regular-svg-icons/faScrewdriverWrench';
import { faScrewdriverWrench as faScrewdriverWrench__fas } from '@fortawesome/pro-solid-svg-icons/faScrewdriverWrench';
import { faSearch as faSearch__far } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faServer as faServer__far } from '@fortawesome/pro-regular-svg-icons/faServer';
import { faServer as faServer__fas } from '@fortawesome/pro-solid-svg-icons/faServer';
import { faShare as faShare__far } from '@fortawesome/pro-regular-svg-icons/faShare';
import { faShieldCheck as faShieldCheck__far } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';
import { faShieldCheck as faShieldCheck__fas } from '@fortawesome/pro-solid-svg-icons/faShieldCheck';
import { faShieldHalved as faShieldHalved__far } from '@fortawesome/pro-regular-svg-icons/faShieldHalved';
import { faShieldHalved as faShieldHalved__fas } from '@fortawesome/pro-solid-svg-icons/faShieldHalved';
import { faShuffle as faShuffle__far } from '@fortawesome/pro-regular-svg-icons/faShuffle';
import { faShuffle as faShuffle__fas } from '@fortawesome/pro-solid-svg-icons/faShuffle';
import { faSitemap as faSitemap__far } from '@fortawesome/pro-regular-svg-icons/faSitemap';
import { faSitemap as faSitemap__fas } from '@fortawesome/pro-solid-svg-icons/faSitemap';
import { faSliders as faSliders__far } from '@fortawesome/pro-regular-svg-icons/faSliders';
import { faSliders as faSliders__fas } from '@fortawesome/pro-solid-svg-icons/faSliders';
import { faSlidersSimple as faSlidersSimple__far } from '@fortawesome/pro-regular-svg-icons/faSlidersSimple';
import { faSparkles as faSparkles__far } from '@fortawesome/pro-regular-svg-icons/faSparkles';
import { faSparkles as faSparkles__fas } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faSpinner as faSpinner__far } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { faSpinner as faSpinner__fas } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faSquare as faSquare__far } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faSquare as faSquare__fas } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { faSquareCheck as faSquareCheck__far } from '@fortawesome/pro-regular-svg-icons/faSquareCheck';
import { faSquareCheck as faSquareCheck__fas } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { faStar as faStar__far } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faStar as faStar__fas } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStars as faStars__far } from '@fortawesome/pro-regular-svg-icons/faStars';
import { faStethoscope as faStethoscope__far } from '@fortawesome/pro-regular-svg-icons/faStethoscope';
import { faStopwatch as faStopwatch__far } from '@fortawesome/pro-regular-svg-icons/faStopwatch';
import { faStore as faStore__far } from '@fortawesome/pro-regular-svg-icons/faStore';
import { faStore as faStore__fas } from '@fortawesome/pro-solid-svg-icons/faStore';
import { faSun as faSun__far } from '@fortawesome/pro-regular-svg-icons/faSun';
import { faSun as faSun__fas } from '@fortawesome/pro-solid-svg-icons/faSun';
import { faTable as faTable__far } from '@fortawesome/pro-regular-svg-icons/faTable';
import { faTable as faTable__fas } from '@fortawesome/pro-solid-svg-icons/faTable';
import { faTableColumns as faTableColumns__far } from '@fortawesome/pro-regular-svg-icons/faTableColumns';
import { faTableColumns as faTableColumns__fas } from '@fortawesome/pro-solid-svg-icons/faTableColumns';
import { faTag as faTag__far } from '@fortawesome/pro-regular-svg-icons/faTag';
import { faTag as faTag__fas } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faTerminal as faTerminal__far } from '@fortawesome/pro-regular-svg-icons/faTerminal';
import { faTerminal as faTerminal__fas } from '@fortawesome/pro-solid-svg-icons/faTerminal';
import { faThumbsDown as faThumbsDown__far } from '@fortawesome/pro-regular-svg-icons/faThumbsDown';
import { faThumbsDown as faThumbsDown__fas } from '@fortawesome/pro-solid-svg-icons/faThumbsDown';
import { faThumbsUp as faThumbsUp__far } from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import { faThumbsUp as faThumbsUp__fas } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { faThumbtack as faThumbtack__far } from '@fortawesome/pro-regular-svg-icons/faThumbtack';
import { faToolbox as faToolbox__far } from '@fortawesome/pro-regular-svg-icons/faToolbox';
import { faToolbox as faToolbox__fas } from '@fortawesome/pro-solid-svg-icons/faToolbox';
import { faTractor as faTractor__far } from '@fortawesome/pro-regular-svg-icons/faTractor';
import { faTractor as faTractor__fas } from '@fortawesome/pro-solid-svg-icons/faTractor';
import { faTrain as faTrain__far } from '@fortawesome/pro-regular-svg-icons/faTrain';
import { faTrash as faTrash__far } from '@fortawesome/pro-regular-svg-icons/faTrash';
import { faTrash as faTrash__fas } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTriangleExclamation as faTriangleExclamation__far } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faTriangleExclamation as faTriangleExclamation__fas } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faUpload as faUpload__far } from '@fortawesome/pro-regular-svg-icons/faUpload';
import { faUpload as faUpload__fas } from '@fortawesome/pro-solid-svg-icons/faUpload';
import { faUser as faUser__far } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUser as faUser__fas } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserCheck as faUserCheck__far } from '@fortawesome/pro-regular-svg-icons/faUserCheck';
import { faUserGroup as faUserGroup__far } from '@fortawesome/pro-regular-svg-icons/faUserGroup';
import { faUserPlus as faUserPlus__far } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { faUserSecret as faUserSecret__far } from '@fortawesome/pro-regular-svg-icons/faUserSecret';
import { faUserSecret as faUserSecret__fas } from '@fortawesome/pro-solid-svg-icons/faUserSecret';
import { faUserTie as faUserTie__far } from '@fortawesome/pro-regular-svg-icons/faUserTie';
import { faUserTie as faUserTie__fas } from '@fortawesome/pro-solid-svg-icons/faUserTie';
import { faUsers as faUsers__far } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faUsers as faUsers__fas } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUtensils as faUtensils__far } from '@fortawesome/pro-regular-svg-icons/faUtensils';
import { faUtensils as faUtensils__fas } from '@fortawesome/pro-solid-svg-icons/faUtensils';
import { faVideo as faVideo__far } from '@fortawesome/pro-regular-svg-icons/faVideo';
import { faVideo as faVideo__fas } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faVolume as faVolume__far } from '@fortawesome/pro-regular-svg-icons/faVolume';
import { faVolumeHigh as faVolumeHigh__far } from '@fortawesome/pro-regular-svg-icons/faVolumeHigh';
import { faVolumeHigh as faVolumeHigh__fas } from '@fortawesome/pro-solid-svg-icons/faVolumeHigh';
import { faWallet as faWallet__far } from '@fortawesome/pro-regular-svg-icons/faWallet';
import { faWallet as faWallet__fas } from '@fortawesome/pro-solid-svg-icons/faWallet';
import { faWandMagicSparkles as faWandMagicSparkles__far } from '@fortawesome/pro-regular-svg-icons/faWandMagicSparkles';
import { faWandMagicSparkles as faWandMagicSparkles__fas } from '@fortawesome/pro-solid-svg-icons/faWandMagicSparkles';
import { faWaveform as faWaveform__far } from '@fortawesome/pro-regular-svg-icons/faWaveform';
import { faWaveform as faWaveform__fas } from '@fortawesome/pro-solid-svg-icons/faWaveform';
import { faWindowMaximize as faWindowMaximize__far } from '@fortawesome/pro-regular-svg-icons/faWindowMaximize';
import { faWindowMaximize as faWindowMaximize__fas } from '@fortawesome/pro-solid-svg-icons/faWindowMaximize';
import { faX as faX__far } from '@fortawesome/pro-regular-svg-icons/faX';
import { faXmark as faXmark__far } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faXmark as faXmark__fas } from '@fortawesome/pro-solid-svg-icons/faXmark';

const ICON_DEFINITIONS = {
  'fal:circle': faCircle__fal,
  'fal:circle-check': faCircleCheck__fal,
  'fal:clock-rotate-left': faClockRotateLeft__fal,
  'fal:mobile-screen': faMobileScreen__fal,
  'far:align-left': faAlignLeft__far,
  'far:angle-left': faAngleLeft__far,
  'far:angle-right': faAngleRight__far,
  'far:archive': faArchive__far,
  'far:arrow-down': faArrowDown__far,
  'far:arrow-down-a-z': faArrowDownAZ__far,
  'far:arrow-down-to-line': faArrowDownToLine__far,
  'far:arrow-left': faArrowLeft__far,
  'far:arrow-right': faArrowRight__far,
  'far:arrow-right-from-bracket': faArrowRightFromBracket__far,
  'far:arrow-right-to-bracket': faArrowRightToBracket__far,
  'far:arrow-rotate-right': faArrowRotateRight__far,
  'far:arrow-trend-up': faArrowTrendUp__far,
  'far:arrow-up': faArrowUp__far,
  'far:arrow-up-right': faArrowUpRight__far,
  'far:arrow-up-right-from-square': faArrowUpRightFromSquare__far,
  'far:arrow-up-wide-short': faArrowUpWideShort__far,
  'far:arrows-rotate': faArrowsRotate__far,
  'far:arrows-to-dotted-line': faArrowsToDottedLine__far,
  'far:bag-shopping': faBagShopping__far,
  'far:ban': faBan__far,
  'far:bars': faBars__far,
  'far:battery-empty': faBatteryEmpty__far,
  'far:bolt': faBolt__far,
  'far:book': faBook__far,
  'far:book-blank': faBookBlank__far,
  'far:book-open': faBookOpen__far,
  'far:bookmark': faBookmark__far,
  'far:box': faBox__far,
  'far:box-archive': faBoxArchive__far,
  'far:box-open': faBoxOpen__far,
  'far:brain': faBrain__far,
  'far:briefcase': faBriefcase__far,
  'far:brightness': faBrightness__far,
  'far:building': faBuilding__far,
  'far:bullhorn': faBullhorn__far,
  'far:bullseye': faBullseye__far,
  'far:calculator': faCalculator__far,
  'far:calendar': faCalendar__far,
  'far:calendar-check': faCalendarCheck__far,
  'far:calendar-clock': faCalendarClock__far,
  'far:calendar-days': faCalendarDays__far,
  'far:calendar-plus': faCalendarPlus__far,
  'far:cart-plus': faCartPlus__far,
  'far:cart-shopping': faCartShopping__far,
  'far:chalkboard': faChalkboard__far,
  'far:chalkboard-user': faChalkboardUser__far,
  'far:chart-column': faChartColumn__far,
  'far:chart-line': faChartLine__far,
  'far:chart-pie': faChartPie__far,
  'far:chart-simple': faChartSimple__far,
  'far:check': faCheck__far,
  'far:chevron-down': faChevronDown__far,
  'far:chevron-left': faChevronLeft__far,
  'far:chevron-right': faChevronRight__far,
  'far:chevron-up': faChevronUp__far,
  'far:church': faChurch__far,
  'far:circle': faCircle__far,
  'far:circle-arrow-down': faCircleArrowDown__far,
  'far:circle-check': faCircleCheck__far,
  'far:circle-exclamation': faCircleExclamation__far,
  'far:circle-info': faCircleInfo__far,
  'far:circle-notch': faCircleNotch__far,
  'far:circle-plus': faCirclePlus__far,
  'far:circle-question': faCircleQuestion__far,
  'far:circle-stop': faCircleStop__far,
  'far:circle-user': faCircleUser__far,
  'far:circle-xmark': faCircleXmark__far,
  'far:clapperboard': faClapperboard__far,
  'far:clipboard': faClipboard__far,
  'far:clipboard-check': faClipboardCheck__far,
  'far:clipboard-list': faClipboardList__far,
  'far:clock': faClock__far,
  'far:clock-rotate-left': faClockRotateLeft__far,
  'far:clone': faClone__far,
  'far:cloud-arrow-up': faCloudArrowUp__far,
  'far:code': faCode__far,
  'far:code-branch': faCodeBranch__far,
  'far:code-compare': faCodeCompare__far,
  'far:coffee': faCoffee__far,
  'far:coins': faCoins__far,
  'far:comment': faComment__far,
  'far:comment-dots': faCommentDots__far,
  'far:comments': faComments__far,
  'far:compass': faCompass__far,
  'far:compress': faCompress__far,
  'far:copy': faCopy__far,
  'far:credit-card': faCreditCard__far,
  'far:cross': faCross__far,
  'far:crown': faCrown__far,
  'far:cube': faCube__far,
  'far:cubes': faCubes__far,
  'far:desktop': faDesktop__far,
  'far:diagram-project': faDiagramProject__far,
  'far:download': faDownload__far,
  'far:dumbbell': faDumbbell__far,
  'far:ellipsis': faEllipsis__far,
  'far:envelope': faEnvelope__far,
  'far:envelope-circle-check': faEnvelopeCircleCheck__far,
  'far:eraser': faEraser__far,
  'far:eye': faEye__far,
  'far:eye-slash': faEyeSlash__far,
  'far:file': faFile__far,
  'far:file-arrow-up': faFileArrowUp__far,
  'far:file-audio': faFileAudio__far,
  'far:file-cad': faFileCad__far,
  'far:file-code': faFileCode__far,
  'far:file-csv': faFileCsv__far,
  'far:file-doc': faFileDoc__far,
  'far:file-eps': faFileEps__far,
  'far:file-excel': faFileExcel__far,
  'far:file-export': faFileExport__far,
  'far:file-gif': faFileGif__far,
  'far:file-image': faFileImage__far,
  'far:file-import': faFileImport__far,
  'far:file-jpg': faFileJpg__far,
  'far:file-lines': faFileLines__far,
  'far:file-mov': faFileMov__far,
  'far:file-mp3': faFileMp3__far,
  'far:file-mp4': faFileMp4__far,
  'far:file-pdf': faFilePdf__far,
  'far:file-plus': faFilePlus__far,
  'far:file-png': faFilePng__far,
  'far:file-powerpoint': faFilePowerpoint__far,
  'far:file-spreadsheet': faFileSpreadsheet__far,
  'far:file-svg': faFileSvg__far,
  'far:file-text': faFileText__far,
  'far:file-video': faFileVideo__far,
  'far:file-word': faFileWord__far,
  'far:file-xml': faFileXml__far,
  'far:file-zipper': faFileZipper__far,
  'far:files': faFiles__far,
  'far:film': faFilm__far,
  'far:filter': faFilter__far,
  'far:filter-list': faFilterList__far,
  'far:fire': faFire__far,
  'far:flag': faFlag__far,
  'far:flag-usa': faFlagUsa__far,
  'far:flask': faFlask__far,
  'far:folder': faFolder__far,
  'far:folder-magnifying-glass': faFolderMagnifyingGlass__far,
  'far:folder-minus': faFolderMinus__far,
  'far:folder-open': faFolderOpen__far,
  'far:folder-plus': faFolderPlus__far,
  'far:folder-tree': faFolderTree__far,
  'far:frog': faFrog__far,
  'far:gamepad': faGamepad__far,
  'far:gauge-high': faGaugeHigh__far,
  'far:gear': faGear__far,
  'far:gears': faGears__far,
  'far:gem': faGem__far,
  'far:ghost': faGhost__far,
  'far:globe': faGlobe__far,
  'far:graduation-cap': faGraduationCap__far,
  'far:grid-2': faGrid2__far,
  'far:hammer': faHammer__far,
  'far:hand': faHand__far,
  'far:hand-holding-dollar': faHandHoldingDollar__far,
  'far:handshake': faHandshake__far,
  'far:heart': faHeart__far,
  'far:heart-pulse': faHeartPulse__far,
  'far:home': faHome__far,
  'far:house': faHouse__far,
  'far:image': faImage__far,
  'far:industry': faIndustry__far,
  'far:infinity': faInfinity__far,
  'far:key': faKey__far,
  'far:landmark': faLandmark__far,
  'far:laptop': faLaptop__far,
  'far:layer-group': faLayerGroup__far,
  'far:lightbulb': faLightbulb__far,
  'far:link': faLink__far,
  'far:list': faList__far,
  'far:list-check': faListCheck__far,
  'far:list-ol': faListOl__far,
  'far:location-dot': faLocationDot__far,
  'far:lock': faLock__far,
  'far:magnifying-glass': faMagnifyingGlass__far,
  'far:magnifying-glass-chart': faMagnifyingGlassChart__far,
  'far:message': faMessage__far,
  'far:message-dots': faMessageDots__far,
  'far:messages': faMessages__far,
  'far:microchip': faMicrochip__far,
  'far:microphone': faMicrophone__far,
  'far:microphone-lines': faMicrophoneLines__far,
  'far:minus': faMinus__far,
  'far:mobile': faMobile__far,
  'far:mobile-screen': faMobileScreen__far,
  'far:mobile-screen-button': faMobileScreenButton__far,
  'far:moon': faMoon__far,
  'far:mountain-sun': faMountainSun__far,
  'far:mug-hot': faMugHot__far,
  'far:music': faMusic__far,
  'far:newspaper': faNewspaper__far,
  'far:object-group': faObjectGroup__far,
  'far:paintbrush': faPaintbrush__far,
  'far:palette': faPalette__far,
  'far:paper-plane': faPaperPlane__far,
  'far:paperclip': faPaperclip__far,
  'far:pause': faPause__far,
  'far:pen': faPen__far,
  'far:pen-fancy': faPenFancy__far,
  'far:pen-nib': faPenNib__far,
  'far:pen-to-square': faPenToSquare__far,
  'far:pencil': faPencil__far,
  'far:people-roof': faPeopleRoof__far,
  'far:phone': faPhone__far,
  'far:play': faPlay__far,
  'far:plug': faPlug__far,
  'far:plus': faPlus__far,
  'far:puzzle-piece': faPuzzlePiece__far,
  'far:question': faQuestion__far,
  'far:quotes': faQuotes__far,
  'far:right-left': faRightLeft__far,
  'far:robot': faRobot__far,
  'far:rocket': faRocket__far,
  'far:route': faRoute__far,
  'far:scale-balanced': faScaleBalanced__far,
  'far:screwdriver-wrench': faScrewdriverWrench__far,
  'far:search': faSearch__far,
  'far:server': faServer__far,
  'far:share': faShare__far,
  'far:shield-check': faShieldCheck__far,
  'far:shield-halved': faShieldHalved__far,
  'far:shuffle': faShuffle__far,
  'far:sitemap': faSitemap__far,
  'far:sliders': faSliders__far,
  'far:sliders-simple': faSlidersSimple__far,
  'far:sparkles': faSparkles__far,
  'far:spinner': faSpinner__far,
  'far:square': faSquare__far,
  'far:square-check': faSquareCheck__far,
  'far:star': faStar__far,
  'far:stars': faStars__far,
  'far:stethoscope': faStethoscope__far,
  'far:stopwatch': faStopwatch__far,
  'far:store': faStore__far,
  'far:sun': faSun__far,
  'far:table': faTable__far,
  'far:table-columns': faTableColumns__far,
  'far:tag': faTag__far,
  'far:terminal': faTerminal__far,
  'far:thumbs-down': faThumbsDown__far,
  'far:thumbs-up': faThumbsUp__far,
  'far:thumbtack': faThumbtack__far,
  'far:toolbox': faToolbox__far,
  'far:tractor': faTractor__far,
  'far:train': faTrain__far,
  'far:trash': faTrash__far,
  'far:triangle-exclamation': faTriangleExclamation__far,
  'far:upload': faUpload__far,
  'far:user': faUser__far,
  'far:user-check': faUserCheck__far,
  'far:user-group': faUserGroup__far,
  'far:user-plus': faUserPlus__far,
  'far:user-secret': faUserSecret__far,
  'far:user-tie': faUserTie__far,
  'far:users': faUsers__far,
  'far:utensils': faUtensils__far,
  'far:video': faVideo__far,
  'far:volume': faVolume__far,
  'far:volume-high': faVolumeHigh__far,
  'far:wallet': faWallet__far,
  'far:wand-magic-sparkles': faWandMagicSparkles__far,
  'far:waveform': faWaveform__far,
  'far:window-maximize': faWindowMaximize__far,
  'far:x': faX__far,
  'far:xmark': faXmark__far,
  'fas:angle-right': faAngleRight__fas,
  'fas:arrow-down': faArrowDown__fas,
  'fas:arrow-down-to-line': faArrowDownToLine__fas,
  'fas:arrow-right': faArrowRight__fas,
  'fas:arrow-right-from-bracket': faArrowRightFromBracket__fas,
  'fas:arrow-right-to-bracket': faArrowRightToBracket__fas,
  'fas:arrow-rotate-right': faArrowRotateRight__fas,
  'fas:arrow-up': faArrowUp__fas,
  'fas:arrow-up-right': faArrowUpRight__fas,
  'fas:arrow-up-right-from-square': faArrowUpRightFromSquare__fas,
  'fas:arrows-rotate': faArrowsRotate__fas,
  'fas:bag-shopping': faBagShopping__fas,
  'fas:ban': faBan__fas,
  'fas:bars': faBars__fas,
  'fas:bolt': faBolt__fas,
  'fas:book': faBook__fas,
  'fas:book-open': faBookOpen__fas,
  'fas:bookmark': faBookmark__fas,
  'fas:box-archive': faBoxArchive__fas,
  'fas:box-open': faBoxOpen__fas,
  'fas:brain': faBrain__fas,
  'fas:briefcase': faBriefcase__fas,
  'fas:building': faBuilding__fas,
  'fas:bullhorn': faBullhorn__fas,
  'fas:bullseye': faBullseye__fas,
  'fas:calendar-check': faCalendarCheck__fas,
  'fas:calendar-clock': faCalendarClock__fas,
  'fas:calendar-days': faCalendarDays__fas,
  'fas:cart-shopping': faCartShopping__fas,
  'fas:chalkboard': faChalkboard__fas,
  'fas:chalkboard-user': faChalkboardUser__fas,
  'fas:chart-column': faChartColumn__fas,
  'fas:chart-line': faChartLine__fas,
  'fas:chart-pie': faChartPie__fas,
  'fas:chart-simple': faChartSimple__fas,
  'fas:check': faCheck__fas,
  'fas:chevron-down': faChevronDown__fas,
  'fas:chevron-left': faChevronLeft__fas,
  'fas:chevron-right': faChevronRight__fas,
  'fas:chevron-up': faChevronUp__fas,
  'fas:church': faChurch__fas,
  'fas:circle': faCircle__fas,
  'fas:circle-check': faCircleCheck__fas,
  'fas:circle-exclamation': faCircleExclamation__fas,
  'fas:circle-info': faCircleInfo__fas,
  'fas:circle-notch': faCircleNotch__fas,
  'fas:circle-question': faCircleQuestion__fas,
  'fas:circle-xmark': faCircleXmark__fas,
  'fas:clapperboard': faClapperboard__fas,
  'fas:clipboard-check': faClipboardCheck__fas,
  'fas:clipboard-list': faClipboardList__fas,
  'fas:clock': faClock__fas,
  'fas:clock-rotate-left': faClockRotateLeft__fas,
  'fas:clone': faClone__fas,
  'fas:code': faCode__fas,
  'fas:code-branch': faCodeBranch__fas,
  'fas:coins': faCoins__fas,
  'fas:comment': faComment__fas,
  'fas:comments': faComments__fas,
  'fas:compass': faCompass__fas,
  'fas:copy': faCopy__fas,
  'fas:credit-card': faCreditCard__fas,
  'fas:cross': faCross__fas,
  'fas:crown': faCrown__fas,
  'fas:cube': faCube__fas,
  'fas:cubes': faCubes__fas,
  'fas:desktop': faDesktop__fas,
  'fas:diagram-project': faDiagramProject__fas,
  'fas:dumbbell': faDumbbell__fas,
  'fas:envelope': faEnvelope__fas,
  'fas:eraser': faEraser__fas,
  'fas:eye': faEye__fas,
  'fas:file': faFile__fas,
  'fas:file-code': faFileCode__fas,
  'fas:file-export': faFileExport__fas,
  'fas:file-import': faFileImport__fas,
  'fas:file-lines': faFileLines__fas,
  'fas:file-pdf': faFilePdf__fas,
  'fas:file-powerpoint': faFilePowerpoint__fas,
  'fas:file-spreadsheet': faFileSpreadsheet__fas,
  'fas:film': faFilm__fas,
  'fas:fire': faFire__fas,
  'fas:flask': faFlask__fas,
  'fas:folder': faFolder__fas,
  'fas:folder-open': faFolderOpen__fas,
  'fas:folder-tree': faFolderTree__fas,
  'fas:gamepad': faGamepad__fas,
  'fas:gauge-high': faGaugeHigh__fas,
  'fas:gears': faGears__fas,
  'fas:gem': faGem__fas,
  'fas:ghost': faGhost__fas,
  'fas:globe': faGlobe__fas,
  'fas:graduation-cap': faGraduationCap__fas,
  'fas:grid-2': faGrid2__fas,
  'fas:hammer': faHammer__fas,
  'fas:hand': faHand__fas,
  'fas:hand-holding-dollar': faHandHoldingDollar__fas,
  'fas:handshake': faHandshake__fas,
  'fas:heart': faHeart__fas,
  'fas:heart-pulse': faHeartPulse__fas,
  'fas:home': faHome__fas,
  'fas:house': faHouse__fas,
  'fas:image': faImage__fas,
  'fas:key': faKey__fas,
  'fas:landmark': faLandmark__fas,
  'fas:laptop': faLaptop__fas,
  'fas:layer-group': faLayerGroup__fas,
  'fas:lightbulb': faLightbulb__fas,
  'fas:link': faLink__fas,
  'fas:list': faList__fas,
  'fas:list-check': faListCheck__fas,
  'fas:list-ol': faListOl__fas,
  'fas:location-dot': faLocationDot__fas,
  'fas:lock': faLock__fas,
  'fas:magnifying-glass': faMagnifyingGlass__fas,
  'fas:magnifying-glass-chart': faMagnifyingGlassChart__fas,
  'fas:message': faMessage__fas,
  'fas:microchip': faMicrochip__fas,
  'fas:microphone': faMicrophone__fas,
  'fas:microphone-lines': faMicrophoneLines__fas,
  'fas:minus': faMinus__fas,
  'fas:mobile-screen': faMobileScreen__fas,
  'fas:mobile-screen-button': faMobileScreenButton__fas,
  'fas:moon': faMoon__fas,
  'fas:mountain-sun': faMountainSun__fas,
  'fas:mug-hot': faMugHot__fas,
  'fas:music': faMusic__fas,
  'fas:newspaper': faNewspaper__fas,
  'fas:object-group': faObjectGroup__fas,
  'fas:paintbrush': faPaintbrush__fas,
  'fas:palette': faPalette__fas,
  'fas:paper-plane': faPaperPlane__fas,
  'fas:pause': faPause__fas,
  'fas:pen': faPen__fas,
  'fas:pen-fancy': faPenFancy__fas,
  'fas:pen-nib': faPenNib__fas,
  'fas:pen-to-square': faPenToSquare__fas,
  'fas:pencil': faPencil__fas,
  'fas:people-roof': faPeopleRoof__fas,
  'fas:phone': faPhone__fas,
  'fas:play': faPlay__fas,
  'fas:plug': faPlug__fas,
  'fas:plus': faPlus__fas,
  'fas:quotes': faQuotes__fas,
  'fas:right-left': faRightLeft__fas,
  'fas:robot': faRobot__fas,
  'fas:rocket': faRocket__fas,
  'fas:scale-balanced': faScaleBalanced__fas,
  'fas:screwdriver-wrench': faScrewdriverWrench__fas,
  'fas:server': faServer__fas,
  'fas:shield-check': faShieldCheck__fas,
  'fas:shield-halved': faShieldHalved__fas,
  'fas:shuffle': faShuffle__fas,
  'fas:sitemap': faSitemap__fas,
  'fas:sliders': faSliders__fas,
  'fas:sparkles': faSparkles__fas,
  'fas:spinner': faSpinner__fas,
  'fas:square': faSquare__fas,
  'fas:square-check': faSquareCheck__fas,
  'fas:star': faStar__fas,
  'fas:store': faStore__fas,
  'fas:sun': faSun__fas,
  'fas:table': faTable__fas,
  'fas:table-columns': faTableColumns__fas,
  'fas:tag': faTag__fas,
  'fas:terminal': faTerminal__fas,
  'fas:thumbs-down': faThumbsDown__fas,
  'fas:thumbs-up': faThumbsUp__fas,
  'fas:toolbox': faToolbox__fas,
  'fas:tractor': faTractor__fas,
  'fas:trash': faTrash__fas,
  'fas:triangle-exclamation': faTriangleExclamation__fas,
  'fas:upload': faUpload__fas,
  'fas:user': faUser__fas,
  'fas:user-secret': faUserSecret__fas,
  'fas:user-tie': faUserTie__fas,
  'fas:users': faUsers__fas,
  'fas:utensils': faUtensils__fas,
  'fas:video': faVideo__fas,
  'fas:volume-high': faVolumeHigh__fas,
  'fas:wallet': faWallet__fas,
  'fas:wand-magic-sparkles': faWandMagicSparkles__fas,
  'fas:waveform': faWaveform__fas,
  'fas:window-maximize': faWindowMaximize__fas,
  'fas:xmark': faXmark__fas,
};

/**
 * Definitions from the deferred map, once it has been loaded. Kept as a separate object
 * rather than merged into ICON_DEFINITIONS so the core map stays a static shape that a
 * minifier can reason about.
 */
const DEFERRED_DEFINITIONS = {};

/**
 * Names that exist in the deferred map. This is names only — no icon data — so it costs
 * a couple of KB and buys the ability to tell "not loaded yet" apart from "no such icon".
 * That distinction is the difference between a blank box that fills in and a permanent
 * question mark, and callers need it to decide whether to trigger a load.
 */
const DEFERRED_NAMES = new Set([
  'align-center',
  'align-justify',
  'align-right',
  'angles-up-down',
  'arrow-down-to-bracket',
  'arrow-down-wide-short',
  'arrow-down-z-a',
  'arrow-left-from-bracket',
  'arrow-left-to-line',
  'arrow-right-arrow-left',
  'arrow-right-to-line',
  'arrow-rotate-left',
  'arrow-turn-down-right',
  'arrow-up-1-9',
  'arrow-up-a-z',
  'arrow-up-from-arc',
  'arrow-up-from-bracket',
  'arrow-up-left',
  'arrow-up-to-line',
  'arrow-up-z-a',
  'arrows-left-right',
  'arrows-spin',
  'backward-step',
  'bars-staggered',
  'bell',
  'bitcoin-sign',
  'bold',
  'book-bible',
  'book-bookmark',
  'book-open-cover',
  'book-open-reader',
  'boombox',
  'border-top-left',
  'brackets-curly',
  'broom',
  'brush',
  'building-columns',
  'cake-candles',
  'calendar-day',
  'calendar-range',
  'calendar-star',
  'calendar-week',
  'camera',
  'camera-movie',
  'camera-rotate',
  'car',
  'champagne-glasses',
  'chart-area',
  'check-double',
  'chess',
  'chess-rook',
  'child',
  'child-reaching',
  'children',
  'circle-arrow-right',
  'circle-dollar',
  'circle-dot',
  'circle-minus',
  'circle-pause',
  'circle-play',
  'city',
  'closed-captioning',
  'cloud',
  'cloud-arrow-down',
  'cloud-plus',
  'code-commit',
  'code-fork',
  'code-merge',
  'coin',
  'columns-3',
  'compact-disc',
  'compass-drafting',
  'copyright',
  'couch',
  'cubes-stacked',
  'database',
  'dice-d20',
  'display',
  'dog',
  'dove',
  'drafting-compass',
  'dragon',
  'droplet',
  'drum',
  'ear-listen',
  'earth-americas',
  'ellipsis-vertical',
  'envelope-open-text',
  'exclamation-triangle',
  'expand',
  'face-frown',
  'face-laugh',
  'face-laugh-beam',
  'face-smile',
  'facebook-f',
  'feather',
  'feather-pointed',
  'file-circle-plus',
  'fingerprint',
  'fire-burner',
  'floppy-disk',
  'flower',
  'folder-arrow-down',
  'font',
  'football',
  'function',
  'gift',
  'globe-stand',
  'guitar',
  'hand-holding-heart',
  'hands-holding-heart',
  'hands-praying',
  'hashtag',
  'hat-cowboy',
  'hat-wizard',
  'heading',
  'headphones',
  'headset',
  'house-chimney',
  'image-slash',
  'images',
  'inbox',
  'input-text',
  'italic',
  'keyboard',
  'language',
  'leaf',
  'linkedin-in',
  'list-tree',
  'list-ul',
  'location-arrow',
  'magnifying-glass-plus',
  'map',
  'map-location-dot',
  'medal',
  'message-lines',
  'meteor',
  'microphone-slash',
  'note-sticky',
  'notebook',
  'paint-roller',
  'paintbrush-pencil',
  'paste',
  'paw',
  'pen-ruler',
  'people-group',
  'percent',
  'plane',
  'plane-departure',
  'play-circle',
  'podcast',
  'popcorn',
  'pray',
  'print',
  'quote-right',
  'radio',
  'receipt',
  'record-vinyl',
  'rectangle-ad',
  'rectangle-list',
  'rectangle-wide',
  'rectangle-xmark',
  'reddit-alien',
  'repeat',
  'road',
  'rotate-left',
  'rotate-right',
  'rss',
  'saxophone',
  'school',
  'scissors',
  'seedling',
  'shapes',
  'share-from-square',
  'share-nodes',
  'shield',
  'shirt',
  'shoe-prints',
  'signature',
  'skull',
  'spa',
  'sparkle',
  'spell-check',
  'spray-can',
  'square-a',
  'square-dashed',
  'square-minus',
  'square-terminal',
  'stamp',
  'star-half-stroke',
  'star-of-life',
  'stream',
  'strikethrough',
  'swatchbook',
  'table-cells',
  'table-list',
  'tags',
  'tasks',
  'text',
  'th-large',
  'thermometer',
  'ticket',
  'toggle-on',
  'trash-can',
  'tree-large',
  'trophy',
  'tv',
  'universal-access',
  'up-right-and-down-left-from-center',
  'user-astronaut',
  'user-gear',
  'user-lock',
  'user-minus',
  'user-pen',
  'user-shield',
  'vector-square',
  'vial',
  'video-slash',
  'vr-cardboard',
  'wave-square',
  'waveform-lines',
  'weight-hanging',
  'wifi',
  'wine-glass',
  'wrench',
  'x-twitter',
  'xmark-circle',
]);

const ALIAS_TABLE = {
  "color-palette": "palette",
  "quote": "quotes",
  "rotate": "arrow-rotate-right",
  "quote-left": "quotes",
  "close": "xmark",
  "check-circle": "circle-check",
  "times-circle": "circle-xmark",
  "exclamation-circle": "circle-exclamation",
  "info-circle": "circle-info",
  "question-circle": "circle-question",
  "minus-circle": "circle-minus",
  "plus-circle": "circle-plus",
  "user-circle": "circle-user",
  "youtube": "video",
  "time": "clock",
  "time-outline": "clock",
  "chatbubble": "message",
  "clock-three": "clock",
  "timer": "stopwatch",
  "rectangle-widescreen": "rectangle-wide",
  "text-outline": "arrow-down-z-a",
  "delete": "trash-can",
  "folder-add": "folder-plus",
  "right-to-bracket": "arrow-right-to-bracket",
  "apps": "grid-2",
  "fa-clipboard": "clipboard",
  "fa-file-text-o": "file-lines",
  "fa-exchange": "arrow-right-arrow-left",
  "fa-exclamation-triangle": "triangle-exclamation",
  "fa-history": "clock-rotate-left",
  "fa-lightbulb-o": "lightbulb",
  "fa-exchange-alt": "arrow-right-arrow-left",
  "fa-clipboard-list": "clipboard-list",
  "fa-arrow-up-from-arc": "arrow-up-from-arc",
  "file-book": "book-blank",
};

/** kebab-case name → canonical name, applying the alias table. */
export function normalizeIconKey(name) {
  if (!name || typeof name !== 'string') return null;
  const key = String(name).trim().toLowerCase();
  return ALIAS_TABLE[key] || key;
}

/** Merge a loaded deferred map in. Idempotent; called by constants/iconRegistry.js. */
export function registerDeferredIconDefinitions(definitions) {
  if (!definitions) return;
  Object.assign(DEFERRED_DEFINITIONS, definitions);
}

/** True if this name is only available from the deferred map, which is not yet loaded. */
export function isDeferredIconPending(name, variant = 'far') {
  const normalized = normalizeIconKey(name);
  if (!normalized || !DEFERRED_NAMES.has(normalized)) return false;
  return !lookup(normalized, variant);
}

function lookup(normalized, variant) {
  for (const source of [ICON_DEFINITIONS, DEFERRED_DEFINITIONS]) {
    const primary = source[`${variant}:${normalized}`];
    if (primary) return primary;
  }
  for (const fallbackVariant of ['far', 'fas', 'fal']) {
    if (fallbackVariant === variant) continue;
    for (const source of [ICON_DEFINITIONS, DEFERRED_DEFINITIONS]) {
      const hit = source[`${fallbackVariant}:${normalized}`];
      if (hit) return hit;
    }
  }
  return null;
}

/**
 * @param {string} name - kebab-case icon name (e.g. "graduation-cap")
 * @param {'far'|'fas'|'fal'} [variant='far']
 *
 * Returns null rather than the question-mark fallback when the name belongs to the
 * deferred map and it has not arrived yet. Rendering the fallback there would flash a
 * wrong glyph and then replace it, which reads as a bug; an empty box of the right size
 * does not, and Icon already reserves the space.
 */
export function getIconDefinition(name, variant = 'far') {
  if (!name || typeof name !== 'string') {
    return ICON_DEFINITIONS['far:circle'] ?? ICON_DEFINITIONS['far:question'] ?? null;
  }
  const normalized = normalizeIconKey(name);
  const hit = lookup(normalized, variant);
  if (hit) return hit;
  if (DEFERRED_NAMES.has(normalized)) return null;
  return ICON_DEFINITIONS['far:question'] ?? ICON_DEFINITIONS['far:circle'] ?? null;
}

export const ICON_MAP_STATS = {
  names: 268,
  entries: 457,
  imports: 457,
  deferredNames: 227,
  deferredEntries: 350,
};
